import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Badge,
  Box,
  Stat,
  StatGroup,
  StatHelpText,
  StatLabel,
  StatNumber,
} from "@chakra-ui/react";

import Timestamp from "../../../components/timestamp";
import { humanReadableLits } from "../../../helpers/lightning";
import { getPubkeysFromList } from "../../../helpers/nostr/lists";
import useUserContactList from "../../../hooks/use-user-contact-list";
import usePlayerGameStats from "../../games/hooks/use-player-game-stats";
import usePlayerElo from "../../games/hooks/use-player-elo";

export default function UserStatsAccordion({ pubkey }: { pubkey: string }) {
  const contacts = useUserContactList({ pubkey });
  const gameStats = usePlayerGameStats(pubkey);
  const elo = usePlayerElo(pubkey);

  return (
    <Accordion allowMultiple>
      <AccordionItem>
        <h2>
          <AccordionButton>
            <Box as="span" flex="1" textAlign="left">
              Network Stats
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel pb="2">
          <StatGroup gap="4" whiteSpace="pre">
            <Stat>
              <StatLabel>Following</StatLabel>
              <StatNumber>{contacts ? humanReadableLits(getPubkeysFromList(contacts).length) : "Unknown"}</StatNumber>
              {contacts && (
                <StatHelpText>
                  Updated <Timestamp timestamp={contacts.created_at} />
                </StatHelpText>
              )}
            </Stat>
          </StatGroup>
        </AccordionPanel>
      </AccordionItem>
      <AccordionItem>
        <h2>
          <AccordionButton>
            <Box as="span" flex="1" textAlign="left">
              Game Stats
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel pb="2">
          <StatGroup gap="4" whiteSpace="pre">
            <Stat>
              <StatLabel>W / L / D</StatLabel>
              <StatNumber>{gameStats.wins} / {gameStats.losses} / {gameStats.draws}</StatNumber>
              {gameStats.totalGames > 0 && (
                <StatHelpText>{gameStats.winRate}% win rate</StatHelpText>
              )}
            </Stat>
            <Stat>
              <StatLabel>Elo Rating</StatLabel>
              <StatNumber>
                {elo.rating}{" "}
                <Badge variant="subtle" color={elo.tierColor} fontSize="xs">
                  {elo.tierName}
                </Badge>
              </StatNumber>
              {elo.rankedGames > 0 && (
                <StatHelpText>{elo.rankedGames} ranked game{elo.rankedGames !== 1 ? "s" : ""}</StatHelpText>
              )}
            </Stat>
          </StatGroup>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
}
